"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function OurFamilyStory() {
  const {
    ref: leftColRef,
    isVisible: isLeftVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: rightColRef,
    isVisible: isRightVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="our-family-story" className="bg-background py-24 lg:py-[160px] overflow-hidden">
      <div className="container mx-auto px-4 md:px-6">
        <div className="grid lg:grid-cols-2 gap-16 lg:gap-24 items-center">
          
          {}
          <div ref={leftColRef} className={`relative transition-all duration-1000 ease-out ${isLeftVisible ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-12"}`}>
            <div className="grid grid-cols-12 items-center">
              <div className="col-span-10 col-start-1 row-start-1">
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1576980/img/finely_done_family_team.png" alt="The Finely Done family team" className="rounded-2xl shadow-lg object-cover aspect-[4/3] w-full" />
              </div>
              <div className="col-span-7 col-start-6 row-start-1 translate-y-1/4 z-10">
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1576980/img/finely_done_early_project.png" alt="An early remodeling project from 20 years ago" className="rounded-2xl shadow-2xl border-8 border-background object-cover aspect-square w-full" />
              </div>
            </div>
          </div>

          {}
          <div ref={rightColRef} className={`flex flex-col gap-8 transition-all duration-1000 delay-200 ease-out ${isRightVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-12"}`}>
            <div className="space-y-4">
              <span className="text-primary font-semibold tracking-widest uppercase text-sm">
                Our Family Story
              </span>
              <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl text-foreground leading-tight">
                A Legacy of Quality
              </h2>
            </div>

            <div className="space-y-6 text-muted-foreground text-lg leading-relaxed">
              <p>
                For over 20 years, Finely Done has been more than just a remodeling company; it is a family tradition built on faith-based values and a deep commitment to our community. We started with a simple goal: to provide honest, high-quality craftsmanship to our neighbors in Hudson, River Falls, Prescott, and Ellsworth.
              </p>
              <p>
                Today, with over 200 successful projects completed, our dedication remains unchanged. We treat every home as if it were our own, ensuring that every custom shower, kitchen layout, and finished basement reflects the premium quality and long-term reliability our clients deserve.
              </p>
            </div>

            <div className="pt-4">
              <Button asChild size="lg" className="text-base px-8 h-14 rounded-md">
                <Link to="/AboutUsPage">
                  Read Our Full Story
                </Link>
              </Button>
            </div>
          </div>

        </div>
      </div>
    </section>;
}